import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useConfig } from 'wagmi'

import { simulationTimestampQueryOptions } from '@/domain/hooks/useSimulationTimestamp'

export interface UsePrefetchSavingsTimestampsParams {
  chainId: number
}

export function usePrefetchSavingsTimestamps({ chainId }: UsePrefetchSavingsTimestampsParams): void {
  const queryClient = useQueryClient()
  const wagmiConfig = useConfig()

  useEffect(() => {
    void queryClient.prefetchQuery(simulationTimestampQueryOptions({ wagmiConfig, chainId }))
  }, [queryClient, wagmiConfig, chainId])
}
